import { render, staticRenderFns } from "./OrderConfirmPanel.vue?vue&type=template&id=5b0ba77f&scoped=true"
import script from "./OrderConfirmPanel.vue?vue&type=script&lang=js"
export * from "./OrderConfirmPanel.vue?vue&type=script&lang=js"
import style0 from "./OrderConfirmPanel.vue?vue&type=style&index=0&id=5b0ba77f&prod&lang=scss&scoped=true"
import style1 from "./OrderConfirmPanel.vue?vue&type=style&index=1&id=5b0ba77f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0ba77f",
  null
  
)

export default component.exports